export const SHOW_APP_LOADING = 'SHOW_APP_LOADING';
export const HIDE_APP_LOADING = 'HIDE_APP_LOADING';

export interface ShowAppLoadingActionType {
  type: typeof SHOW_APP_LOADING;
  payload: {
    message: string;
  };
}

export interface HideAppLoadingActionType {
  type: typeof HIDE_APP_LOADING;
}

export function show(message = ''): ShowAppLoadingActionType {
  return {
    type: SHOW_APP_LOADING,
    payload: {
      message,
    },
  };
}

export function hide(): HideAppLoadingActionType {
  return {
    type: HIDE_APP_LOADING,
  };
}
